import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  cancelIntegrationError,
  cancelIntegrationSuccess,
  fetchSlackDataError,
  fetchSlackDataSuccess,
  fetchTeamsDataError,
  fetchTeamsDataSuccess,
  updateCollaborationAppAlertsError,
  updateCollaborationAppAlertsSuccess,
  updateNotificationsError,
  updateNotificationsSuccess,
} from './actions'
import {
  CANCEL_INTEGRATION_REQUEST,
  FETCH_SLACK_DATA_REQUEST,
  FETCH_TEAMS_DATA_REQUEST,
  SLACK_CONST,
  UPDATE_COLLABORATION_APP_ALERTS_REQUEST,
  UPDATE_NOTIFICATIONS_REQUEST,
} from './constants'

const fetchSlackDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SLACK_DATA_REQUEST.INITIATE,
      UPDATE_NOTIFICATIONS_REQUEST.SUCCESS,
      CANCEL_INTEGRATION_REQUEST.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.collaborationApps)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getCollaborationAppsData(store.getState().partnerOptions.selectedCompany?.value, 'slack')
        .map((response) => fetchSlackDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchSlackDataError, error)))
        .takeUntil(action$.ofType(FETCH_SLACK_DATA_REQUEST.CANCEL))
    )

const fetchTeamsDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_TEAMS_DATA_REQUEST.INITIATE,
      UPDATE_NOTIFICATIONS_REQUEST.SUCCESS,
      CANCEL_INTEGRATION_REQUEST.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.collaborationApps)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getCollaborationAppsData(store.getState().partnerOptions.selectedCompany?.value, 'teams')
        .map((response) => fetchTeamsDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTeamsDataError, error)))
        .takeUntil(action$.ofType(FETCH_TEAMS_DATA_REQUEST.CANCEL))
    )

const updateNotificationsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_NOTIFICATIONS_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .updateCollaborationAppsData(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().settings.notifications.collaborationApps.chosenIntegration === SLACK_CONST
          ? 'slack'
          : 'teams',
        {
          webhookUrl: store.getState().settings.notifications.collaborationApps.webhookUrl,
        }
      )
      .map((response) => updateNotificationsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updateNotificationsError, error)))
      .takeUntil(action$.ofType(UPDATE_NOTIFICATIONS_REQUEST.CANCEL))
  )

const updateCollaborationAppAlertsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_COLLABORATION_APP_ALERTS_REQUEST.INITIATE).mergeMap((action) =>
    api.settings
      .updateCollaborationAppsAlerts(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().settings.notifications.collaborationApps.chosenIntegration === SLACK_CONST
          ? 'slack'
          : 'teams',
        { alerts: action.payload.alerts }
      )
      .mergeMap((response) =>
        Observable.of(
          updateCollaborationAppAlertsSuccess(response),
          addToast({
            message: 'Changes for notifications were saved successfully!',
          })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(updateCollaborationAppAlertsError, error),
          addToast({
            message:
              'Something went wrong. Changes for notifications were not saved. Please contact support.',
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(UPDATE_COLLABORATION_APP_ALERTS_REQUEST.CANCEL))
  )

const cancelIntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CANCEL_INTEGRATION_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .cancelCollaborationAppsIntegration(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().settings.notifications.collaborationApps.chosenIntegration === SLACK_CONST
          ? 'slack'
          : 'teams'
      )
      .map((response) => cancelIntegrationSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(cancelIntegrationError, error)))
      .takeUntil(action$.ofType(CANCEL_INTEGRATION_REQUEST.CANCEL))
  )

export default combineEpics(
  fetchSlackDataEpic,
  fetchTeamsDataEpic,
  updateNotificationsEpic,
  cancelIntegrationEpic,
  updateCollaborationAppAlertsEpic
)
